function vzTocInit() {
  // Early exit: are we in a view of a single post
  if (!document.body.classList.contains('single-post')) {
    return;
  }

  // Check if we have enough H2 headings
  const articleH2 = document.querySelectorAll('.entry-content article h2');
  if (articleH2.length < 3) {
    return;
  }

  // Get modules container with null safety
  const postStats = document.querySelector('.entry-content .post-statistics');
  if (!postStats || !postStats.nextElementSibling) {
    return;
  }

  const modulesContainer = postStats.nextElementSibling;
  const collectH3 = (modulesContainer.dataset.includeH3 === '1');

  // Create accordion structure
  const accordion = document.createElement('nav');
  accordion.classList.add('accordion');
  accordion.dataset.accordion = true;
  accordion.dataset.allowAllClosed = true;

  const accordionItem = document.createElement('div');
  accordionItem.classList.add('accordion-item');
  accordionItem.dataset.accordionItem = true;

  const accordionTitle = document.createElement('a');
  accordionTitle.classList.add('accordion-title');
  accordionTitle.href = '#';
  accordionTitle.textContent = 'Inhaltsverzeichnis';

  const accordionContent = document.createElement('ul');
  accordionContent.classList.add('accordion-content');
  accordionContent.dataset.tabContent = true;

  // Assemble accordion
  accordionItem.appendChild(accordionTitle);
  accordionItem.appendChild(accordionContent);
  accordion.appendChild(accordionItem);

  // Collect all headings
  const headingSelector = collectH3 ? '.entry-content article h2, .entry-content article h3'
    : '.entry-content article h2';
  const articleHeadings = document.querySelectorAll(headingSelector);
  let currentUrl = window.location.href.split('#')[0];
  if (typeof vzGetCurrentUrlWithoutHash === 'function') {
    currentUrl = vzGetCurrentUrlWithoutHash();
  }

  // Use DocumentFragment for better performance
  const fragment = document.createDocumentFragment();
  let currentSubList = null;

  // Process all headings
  articleHeadings.forEach((element, index, list) => {
    // Set unique ID for anchor linking
    const newId = `vzAnchor-${index}`;
    const anchorId = element.id || newId;
    element.id = anchorId;

    // Create list item with anchor
    const item = document.createElement('li');
    const anchor = document.createElement('a');
    anchor.href = `${currentUrl}#${anchorId}`;
    anchor.dataset.smoothScroll = true;
    anchor.dataset.offset = 80;
    anchor.textContent = element.textContent;

    item.appendChild(anchor);

    // Handle H3 nesting
    if (index > 0 && element.tagName === 'H3') {
      // Create new sublist if previous element was H2
      if (list[index - 1].tagName === 'H2') {
        currentSubList = document.createElement('ul');
        fragment.appendChild(currentSubList);
      }
      // Add to current sublist if it exists
      if (currentSubList) {
        currentSubList.appendChild(item);
      } else {
        fragment.appendChild(item);
      }
    } else {
      // H2 or first H3 goes to main list
      fragment.appendChild(item);
      currentSubList = null; // Reset sublist tracking
    }
  });

  // Append all items at once (single reflow)
  accordionContent.appendChild(fragment);

  // Insert accordion before first module
  const firstModule = modulesContainer.firstElementChild;
  modulesContainer.insertBefore(accordion, firstModule);

  // Initialize Foundation accordion (if jQuery is available)
  if (typeof jQuery !== 'undefined' && jQuery.fn.foundation) {
    jQuery(accordion).foundation();
  }
}
